import { cn } from '@lair-finance/util'
import { WalletButton } from '@/domains/header/components/Header/HeaderActions/WalletButton'
import { ConnectButton } from '@/domains/header/components/Header/HeaderActions/ConnectButton.tsx'
import { useAccount } from '@lair-finance/wagmi'
import { SwitchChainButton } from '@/domains/header/components/Header/HeaderActions/SwitchChainButton.tsx'
import { MenuButton } from '@/domains/header/components/Header/HeaderActions/MenuButton.tsx'

export function HeaderActions({ className }: { className?: string }) {
  const account = useAccount()

  return (
    <div className={cn('inline-flex items-center gap-x-3 sm:gap-x-2', className)}>
      <SwitchChainButton />
      {account.isConnected ? <WalletButton /> : <ConnectButton />}
      <MenuButton />
    </div>
  )
}
